// @flow
import * as React from 'react';
import ReactFavicon from 'react-favicon';

import LoginPage from './LoginPage';
import { useProvider } from 'common/modules/provider';
import { Title } from 'common/components/common';

const AppLoginView = (): React.Node => {
    const { assets } = useProvider();
    return (
        <>
            <ReactFavicon url={assets.faviconSrc} />
            <Title i18nKey="settings:dashboardLogin" />
            <LoginPage />
        </>
    );
};

export default AppLoginView;
